import { Link, useLocation } from "react-router-dom";
import { useSidebar } from "../../Context/SidebarContext";

function Item({
  icon,
  name,
  id,
  link,
  handleLogout,
  isSubMenu,
}) {
  // النص الطويل يُقصّ بثلاث نقاط لا بقطعٍ حادّ، واسمه الكامل في التلميح.
  const location = useLocation();
  const { open, closeIfOverlay } = useSidebar();

  const isActive = location.pathname === link;

  return (
    <Link
      to={link}
      id={id}
      onClick={(e) => {
        handleLogout?.(e);
        closeIfOverlay(); // على الجوال/اللوحي تُغلق القائمة بعد اختيار الصفحة
      }}
      className={`
        group
        flex
        items-center
        w-full
        min-h-[var(--asf-nav-item)]
        rounded-[9px]
        mb-1
        font-cairo
        text-[length:var(--asf-text-base)]
        no-underline
        transition-colors
        duration-200
        ease-out
        overflow-visible

        ${open ? "px-2.5" : "px-0 justify-center"}

        ${
          isActive
            ? "bg-white text-secondaryColor"
            : "text-white/90 hover:bg-white/[0.08] hover:text-white"
        }
      `}
    >
      {/* Icon */}
      <i
        className={`
          ${
            isSubMenu && isActive
              ? "fa-regular fa-circle-dot"
              : icon
          }

          text-[length:var(--asf-icon-md)]
          w-[22px]
          min-w-[22px]
          text-center
          shrink-0

          ${open ? "me-3" : ""}
        `}
      />

      {/* Text */}
      {open && (
        <span
          title={name}
          className="
            flex-1
            min-w-0
            overflow-hidden
            text-ellipsis
            whitespace-nowrap
            font-medium
            leading-normal
          "
        >
          {name}
        </span>
      )}
    </Link>
  );
}

export default Item;